import { Menu } from "lucide-react";
import Logo from "../Logo";

export default function TopBar({ onMenu }) {
    return (
        <header className="sticky top-0 z-30 flex items-center justify-between border-b border-white/[0.07] bg-[#0A0C10]/80 px-4 py-3 backdrop-blur-xl lg:hidden">
            <div className="flex items-center gap-2.5">
                <Logo size={28} testid="topbar-logo" />
                <p className="font-display text-sm font-extrabold tracking-wide text-white">
                    EQUIPE STAFF{" "}
                    <span className="font-code text-[10px] font-medium tracking-[0.2em] text-violet-400">
                        [EBH1]
                    </span>
                </p>
            </div>
            <button
                data-testid="mobile-menu-button"
                onClick={onMenu}
                aria-label="Abrir menu"
                className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 text-gray-300 transition-colors hover:bg-white/5"
            >
                <Menu className="h-4 w-4" />
            </button>
        </header>
    );
}
